export default __webpack_public_path__ + "static/media/robot-error.5017bed6.svg";